import { translate } from "app/filters/i18nFilter";
import { roundNumberFilter } from "app/filters/ngFilters";
import { FORMATTERS } from "app/common/benchmark/formatters";

import { SearchOverviewTexts } from "../../texts";

import GraphWidget from "./components/GraphWidget/GraphWidget";
import PieChartWidget from "./components/PieChartWidget/PieChartWidget";
import ProgressBarWidget from "./components/ProgressBarWidget/ProgressBarWidget";
import RankPositionWidget from "./components/RankPositionWidget/RankPositionWidget";
import type { WidgetsConfigSchema } from "./types";
import { SearchMetricName } from "./types";

export const getSearchWidgetsConfig = (): WidgetsConfigSchema => ({
    [SearchMetricName.ALL]: {
        name: SearchMetricName.ALL,
        title: translate(SearchOverviewTexts.searchTrafficTitle),
        tooltipText: translate(SearchOverviewTexts.searchTrafficTooltip),
        component: GraphWidget,
        descriptionText: translate(`analysis.source.search.overview.oftotaltraffic`),
        valueFormatter: (value: number | null) => FORMATTERS.numberAbbr(value),
    },
    [SearchMetricName.ORGANIC]: {
        name: SearchMetricName.ORGANIC,
        title: translate(`analysis.source.search.overview.filters.organic`),
        tooltipText: translate(`analysis.source.search.overview.widgets.organic.tooltip`),
        component: ProgressBarWidget,
        descriptionText: translate(`analysis.source.search.overview.ofsearchtraffic`),
        valueFormatter: (value: number | null) => FORMATTERS.numberAbbr(value),
    },
    [SearchMetricName.PAID]: {
        name: SearchMetricName.PAID,
        title: translate(`analysis.source.search.overview.filters.paid`),
        tooltipText: translate(`analysis.source.search.overview.widgets.paid.tooltip`),
        component: ProgressBarWidget,
        descriptionText: translate(`analysis.source.search.overview.ofsearchtraffic`),
        valueFormatter: (value: number | null) => FORMATTERS.numberAbbr(value),
    },
    [SearchMetricName.RANK_POSITION]: {
        name: SearchMetricName.RANK_POSITION,
        component: RankPositionWidget,
        title: translate(SearchOverviewTexts.rankPositionTitle),
        tooltipText: translate(SearchOverviewTexts.rankPositionTooltip),
        valueFormatter: (value: number | null) => roundNumberFilter()(value),
        descriptionText: translate(`analysis.source.search.overview.ofkeywords`),
        iconButtonHref: {
            name: "arrow-slant-right",
            href: "organicsearch_website_search_ranking_distribution_v2",
            eventSubName: "Rank 1-3",
        },
        noDataStateOnError: (
            <div>
                <div>{translate(SearchOverviewTexts.notSupportedData)}</div>
                <div>{translate(SearchOverviewTexts.tryRecentPeriod)}</div>
            </div>
        ),
    },
    [SearchMetricName.PPC]: {
        name: SearchMetricName.PPC,
        title: translate(`analysis.source.search.overview.widgets.ppcspand`),
        tooltipText: translate(`analysis.source.search.overview.widgets.ppcspand.tooltip`),
        component: GraphWidget,
        descriptionText: translate(`analysis.source.search.overview.costperpaidvisit`),
        valueFormatter: (value: number | null) => FORMATTERS.numberAbbrWithPrefix(value, "$"),
    },
    [SearchMetricName.BRANDED]: {
        name: SearchMetricName.BRANDED,
        title: translate(SearchOverviewTexts.brandedTrafficTitle),
        tooltipText: translate(SearchOverviewTexts.brandedTrafficTooltip),
        component: PieChartWidget,
        styles: { minWidth: "200px" },
    },
});
